<template>
  <div class="home">
    <header>
      <div class="content head-top m-flex">
        <div class="head_left">
          <div class="img-col logo">
            <img
                :src="getWebConfig.logo_image"
                alt=""
            />
          </div>
          <h1 class="fs30 home-title">全国青少年文化艺术创作主题教育竞赛</h1>
        </div>
        <!--<div
          class="login p2 m-right"
          v-if="!userInfo"
          @click="toLogin"
        >
          <span>注册</span>/
          <span>登录</span>
        </div>
        <div
          class="login p2 m-right"
          v-else
          @click="loginOut"
        >
          <span>退出登录</span>
        </div>-->
        <div class="qr-code img-col">
          <img
            :src="getWebConfig.code_image"
            alt=""
          />
        </div>
      </div>
      <div class="content">
        <nav-menu></nav-menu>
      </div>
    </header>

    <!-- <section>
      <el-row>
        <el-col :span="24">
          <router-view />
        </el-col>
      </el-row>
    </section> -->
    <section>
      <router-view />
    </section>

    <footer class="m-flex m-row-center">
      <el-row>
        <el-col
          :span="24"
          class="footer-wrap text-center p4"
        >
          版权所有 未来有我教育科技(北京)有限公司 京ICP备09062181号-5
        </el-col>
      </el-row>
    </footer>
  </div>
</template>

<script>
import NavMenu from "@/components/NavMenu";
import { Stock, chinaMap } from "@/store/mixin.js";
export default {
  name: "index",
  mixins: [Stock, chinaMap],
  components: {
    NavMenu,
  },
  computed: {
    userInfo() {
      return this.$cache.getCache("user_info");
    },
  },
  methods: {
    // 退出登录
    loginOut(){
      this.$cache.delCache('user_info')
      location.reload()
    },
    toLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss">
// 背景色
$bg1: #c91306;
$bg2: #d0392e;
$bg3: #f9f7f8;
$bg4: #ecbfbd;
$bg5: #d04238;
header {
  position: fixed;
  top: 0;
  z-index: 999999;
  width: 100%;
  background: linear-gradient(180deg, $bg1, $bg2);
  .home-title {
    color: #fff;
    font-size: 26px;
    font-weight: 400;
    letter-spacing: 0.2em;
  }
  .head-top {
    display:flex;
    justify-content:space-between;
    height: 110px;
    .head_left{display:flex;align-items:center}
  }
}
section {
  margin-top: 110px+50px;
  overflow: hidden;
  background: linear-gradient(180deg, $bg2, $bg3, $bg4, $bg5);
}
footer {
  padding: 20px;
  height: 80px;
  background: linear-gradient(180deg, #ef4000, #ba0e02);
  color: #ffffff;
}
</style>
